import { locales } from '../../router/routerAliases';

function isRoute(locale: string, match: string) {
  return locales[locale] && Object.values(locales[locale]).find((route) => route === match);
}

export default isRoute;
